<!-- Hero Section -->
<section class="gradient-hero pt-32 pb-20 px-4 relative overflow-hidden">
  <div class="max-w-7xl mx-auto">
    <div class="grid md:grid-cols-2 gap-12 items-center">
      <div class="text-white z-10">
        <div
          class="inline-block bg-white dark:bg-slate-800/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6"
        >
          <span class="text-sm font-medium">✨ Nouveau : IA prédictive V2</span>
        </div>

        <h1 class="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Prépare la
          <span class="underline decoration-yellow-400">bonne quantité</span>, à
          chaque événement
        </h1>

        <p class="text-xl mb-8 text-purple-100 leading-relaxed">
          Le SaaS qui te dit <strong>quoi et combien préparer</strong> pour tes
          événements. Moins de pertes, plus de ventes. Simple, explicable,
          personnalisé.
        </p>

        <div class="flex flex-col sm:flex-row gap-4 mb-8">
          <a
            href="#"
            class="bg-white dark:bg-slate-800 text-purple-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 dark:hover:bg-slate-700 dark:bg-slate-800 transition shadow-xl dark:shadow-slate-900/60 hover:shadow-2xl transform hover:-translate-y-1"
          >
            🚀 Commencer gratuitement
          </a>
          <a
            href="#demo"
            class="bg-purple-800/50 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-purple-800/70 transition border-2 border-white/30"
          >
            📺 Voir la démo (2 min)
          </a>
        </div>

        <div class="flex items-center gap-6 text-sm text-purple-100">
          <div class="flex items-center gap-2">
            <svg
              class="w-5 h-5 text-yellow-400"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
              />
            </svg>
            <span>4.9/5 (127 avis)</span>
          </div>
          <div>✓ Essai gratuit 1 mois</div>
          <div>✓ Sans CB</div>
        </div>
      </div>

      <div class="relative z-10">
        <div
          class="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl p-6 transform hover:scale-105 transition duration-500"
        >
          <div class="flex items-center justify-between mb-4">
            <h3 class="font-bold text-gray-800 dark:text-gray-100">
              Marché de Noël Antibes
            </h3>
            <span
              class="bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 px-3 py-1 rounded-full text-sm font-medium"
              >Prévu</span
            >
          </div>
          <div class="text-sm text-gray-600 dark:text-gray-400 mb-4">
            <div>📅 15 décembre 2024 • ⏰ 10:00 - 18:00</div>
            <div>📍 Antibes • ☀️ Ensoleillé 12°C</div>
          </div>
          <div class="border-t pt-4">
            <div class="flex justify-between items-center mb-2">
              <span class="text-gray-700 dark:text-gray-300 font-medium"
                >🍔 Burger classique</span
              >
              <span class="text-2xl font-bold gradient-text">48</span>
            </div>
            <div
              class="bg-purple-50 dark:bg-purple-900/20 rounded-lg p-3 text-sm text-gray-600 dark:text-gray-400"
            >
              💡 Basé sur 3 événements similaires • Soleil (+20%) • Durée 8h
              (+20%)
            </div>
          </div>
          <button
            class="w-full mt-4 bg-gradient-to-r from-purple-600 to-purple-700 text-white py-3 rounded-lg font-bold hover:from-purple-700 hover:to-purple-800 transition"
          >
            📄 Exporter ma liste
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Stats Section -->
<section class="py-16 bg-white dark:bg-slate-800" id="hero">
  <div class="max-w-7xl mx-auto px-4">
    <div class="grid md:grid-cols-4 gap-8 text-center">
      <div class="scroll-fade-in">
        <div class="stat-number gradient-text">-30%</div>
        <div class="text-gray-600 dark:text-gray-400 mt-2">
          de pertes en moyenne
        </div>
      </div>
      <div class="scroll-fade-in">
        <div class="stat-number gradient-text">+15%</div>
        <div class="text-gray-600 dark:text-gray-400 mt-2">
          de CA supplémentaire
        </div>
      </div>
      <div class="scroll-fade-in">
        <div class="stat-number gradient-text">2 min</div>
        <div class="text-gray-600 dark:text-gray-400 mt-2">
          pour obtenir ta reco
        </div>
      </div>
      <div class="scroll-fade-in">
        <div class="stat-number gradient-text">87%</div>
        <div class="text-gray-600 dark:text-gray-400 mt-2">
          de précision moyenne
        </div>
      </div>
    </div>
  </div>
</section>
